export default "__VITE_ASSET__ClnQSQLJ__"